/** يدعم camelCase و snake_case من الـ API */
function normalizeLeaderboardRow(r) {
  if (!r || typeof r !== 'object') return null;
  const totalScore = r.totalScore ?? r.total_score;
  const avgTimeMs = r.avgTimeMs ?? r.avg_time_ms;
  const daysPracticed = r.daysPracticed ?? r.days_practiced;
  return { ...r, totalScore, avgTimeMs, daysPracticed };
}

export function aggregateLeaderboardCharts(rows) {
  const raw = (rows || []).map(normalizeLeaderboardRow).filter(Boolean);
  const sorted = [...raw].sort((a, b) => (Number(a.rank) || 0) - (Number(b.rank) || 0));
  const lineData = sorted.slice(0, 30).map((r) => {
    const v = r.totalScore;
    const n = Number(v);
    return {
      rank: Number(r.rank) || 0,
      score: Number.isFinite(n) ? n : 0
    };
  });

  const dayBuckets = { '0-3': 0, '4-7': 0, '8-14': 0, '15+': 0, '?': 0 };
  for (const r of raw) {
    const d = Number(r.daysPracticed);
    if (Number.isNaN(d) || r.daysPracticed == null || r.daysPracticed === '') dayBuckets['?'] += 1;
    else if (d <= 3) dayBuckets['0-3'] += 1;
    else if (d <= 7) dayBuckets['4-7'] += 1;
    else if (d <= 14) dayBuckets['8-14'] += 1;
    else dayBuckets['15+'] += 1;
  }
  const byDays = [
    { key: '0-3', count: dayBuckets['0-3'] },
    { key: '4-7', count: dayBuckets['4-7'] },
    { key: '8-14', count: dayBuckets['8-14'] },
    { key: '15+', count: dayBuckets['15+'] },
    { key: '?', count: dayBuckets['?'] }
  ];

  const scatterData = raw
    .filter((r) => r.avgTimeMs != null && r.totalScore != null)
    .slice(0, 200)
    .map((r) => ({
      timeSec: Math.round(Number(r.avgTimeMs) / 1000),
      score: Number(r.totalScore) || 0,
      rank: Number(r.rank) || 0
    }));

  return { lineData, byDays, scatterData };
}

function csvEscapeCell(value) {
  const s = value == null ? '' : String(value);
  if (/[",\r\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

function dayBucketLabel(t, key) {
  const map = {
    '0-3': 'reports.leaderboardCharts.dayBucket_0_3',
    '4-7': 'reports.leaderboardCharts.dayBucket_4_7',
    '8-14': 'reports.leaderboardCharts.dayBucket_8_14',
    '15+': 'reports.leaderboardCharts.dayBucket_15plus',
    '?': 'reports.leaderboardCharts.dayBucket_unknown'
  };
  return t(map[key] || 'reports.leaderboardCharts.dayBucket_unknown');
}

export function buildLeaderboardChartCsvAppend(rows, t) {
  if (!rows || rows.length === 0) return '';
  const { lineData, byDays, scatterData } = aggregateLeaderboardCharts(rows);
  const lines = ['', csvEscapeCell(t('reports.leaderboardCharts.csvBlockTitle')), ''];

  lines.push(csvEscapeCell(t('reports.leaderboardCharts.csvRankScore')));
  lines.push([t('reports.rank'), t('reports.totalScore')].map(csvEscapeCell).join(','));
  for (const row of lineData) {
    lines.push([row.rank, row.score].map(csvEscapeCell).join(','));
  }

  lines.push('');
  lines.push(t('reports.leaderboardCharts.chartDaysBucketsTitle'));
  lines.push(
    [t('reports.leaderboardCharts.daysRange'), t('reports.dailyExercisesApi.chartStudentCount')].map(csvEscapeCell).join(',')
  );
  for (const row of byDays) {
    lines.push([dayBucketLabel(t, row.key), row.count].map(csvEscapeCell).join(','));
  }

  lines.push('');
  lines.push(csvEscapeCell(t('reports.leaderboardCharts.csvScatter')));
  lines.push(
    [t('reports.rank'), t('reports.leaderboardCharts.scatterTimeSec'), t('reports.totalScore')]
      .map(csvEscapeCell)
      .join(',')
  );
  for (const row of scatterData) {
    lines.push([row.rank, row.timeSec, row.score].map(csvEscapeCell).join(','));
  }

  return `\r\n${lines.join('\r\n')}`;
}
